// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {BlockCornerType} from './block-corner-type.js'
import {BlockType} from './block-type.js'
import {Color} from './color.js'
import {ImageAsset} from './image-asset.js'
import {Margins} from './margins.js'
import {Paper} from './paper.js'
import {Point} from './point.js'
import {Rect} from './rect.js'
import {SeqId} from './seq-id.js'
import {Size} from './size.js'
import {TextWrapMode} from './text-wrap-mode.js'

export class CreateBlock {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CreateBlock {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsCreateBlock(bb: flatbuffers.ByteBuffer, obj?: CreateBlock): CreateBlock {
    return (obj || new CreateBlock()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsCreateBlock(bb: flatbuffers.ByteBuffer, obj?: CreateBlock): CreateBlock {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new CreateBlock()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  type(): BlockType {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : BlockType.Text
  }

  corner(): BlockCornerType {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : BlockCornerType.Square
  }

  page(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  origin(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  rotation(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  scale(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  size(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  textWrap(): TextWrapMode {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : TextWrapMode.PixelAlign
  }

  enableCaption(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  image(obj?: ImageAsset): ImageAsset | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? (obj || new ImageAsset()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  cropRect(obj?: Rect): Rect | null {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? (obj || new Rect()).__init(this.bb_pos + offset, this.bb!) : null
  }

  webUrl(): string | null
  webUrl(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  webUrl(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  mathLatex(): string | null
  mathLatex(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  mathLatex(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  mathColor(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  paper(obj?: Paper): Paper | null {
    const offset = this.bb!.__offset(this.bb_pos, 34)
    return offset ? (obj || new Paper()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  imageFlippedHorizontally(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 36)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  imageFlippedVertically(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 38)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  resizesWidthToFitText(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 40)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  margins(obj?: Margins): Margins | null {
    const offset = this.bb!.__offset(this.bb_pos, 42)
    return offset ? (obj || new Margins()).__init(this.bb_pos + offset, this.bb!) : null
  }

  positionLocked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 44)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  static startCreateBlock(builder: flatbuffers.Builder) {
    builder.startObject(21)
  }

  static addType(builder: flatbuffers.Builder, type: BlockType) {
    builder.addFieldInt8(0, type, BlockType.Text)
  }

  static addCorner(builder: flatbuffers.Builder, corner: BlockCornerType) {
    builder.addFieldInt8(1, corner, BlockCornerType.Square)
  }

  static addPage(builder: flatbuffers.Builder, pageOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, pageOffset, 0)
  }

  static addOrigin(builder: flatbuffers.Builder, originOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, originOffset, 0)
  }

  static addRotation(builder: flatbuffers.Builder, rotation: number) {
    builder.addFieldFloat32(4, rotation, null)
  }

  static addScale(builder: flatbuffers.Builder, scaleOffset: flatbuffers.Offset) {
    builder.addFieldStruct(5, scaleOffset, 0)
  }

  static addSize(builder: flatbuffers.Builder, sizeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(6, sizeOffset, 0)
  }

  static addTextWrap(builder: flatbuffers.Builder, textWrap: TextWrapMode) {
    builder.addFieldInt8(7, textWrap, TextWrapMode.PixelAlign)
  }

  static addEnableCaption(builder: flatbuffers.Builder, enableCaption: boolean) {
    builder.addFieldInt8(8, +enableCaption, +false)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(9, zIndex, null)
  }

  static addImage(builder: flatbuffers.Builder, imageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, imageOffset, 0)
  }

  static addCropRect(builder: flatbuffers.Builder, cropRectOffset: flatbuffers.Offset) {
    builder.addFieldStruct(11, cropRectOffset, 0)
  }

  static addWebUrl(builder: flatbuffers.Builder, webUrlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, webUrlOffset, 0)
  }

  static addMathLatex(builder: flatbuffers.Builder, mathLatexOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, mathLatexOffset, 0)
  }

  static addMathColor(builder: flatbuffers.Builder, mathColorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(14, mathColorOffset, 0)
  }

  static addPaper(builder: flatbuffers.Builder, paperOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, paperOffset, 0)
  }

  static addImageFlippedHorizontally(builder: flatbuffers.Builder, imageFlippedHorizontally: boolean) {
    builder.addFieldInt8(16, +imageFlippedHorizontally, +false)
  }

  static addImageFlippedVertically(builder: flatbuffers.Builder, imageFlippedVertically: boolean) {
    builder.addFieldInt8(17, +imageFlippedVertically, +false)
  }

  static addResizesWidthToFitText(builder: flatbuffers.Builder, resizesWidthToFitText: boolean) {
    builder.addFieldInt8(18, +resizesWidthToFitText, +false)
  }

  static addMargins(builder: flatbuffers.Builder, marginsOffset: flatbuffers.Offset) {
    builder.addFieldStruct(19, marginsOffset, 0)
  }

  static addPositionLocked(builder: flatbuffers.Builder, positionLocked: boolean) {
    builder.addFieldInt8(20, +positionLocked, +false)
  }

  static endCreateBlock(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 8) // page
    builder.requiredField(offset, 10) // origin
    builder.requiredField(offset, 16) // size
    return offset
  }
}
